import { useState } from "react";
import { downloadReferenzDocx } from "./api";

interface Props {
  slug: string | null;
  /** Markdown body of the latest referenz, used for client-side .md download. */
  referenzContent: string;
  onNewReferenz: () => void;
}

export function Step3Download({ slug, referenzContent, onNewReferenz }: Props) {
  const [docxBusy, setDocxBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleDocx() {
    if (!slug) return;
    setError(null);
    setDocxBusy(true);
    try {
      const result = await downloadReferenzDocx(slug);
      if (!result.ok) setError(result.error ?? "DOCX-Generierung fehlgeschlagen");
    } finally {
      setDocxBusy(false);
    }
  }

  function handleMarkdown() {
    if (!slug) return;
    const blob = new Blob([referenzContent], { type: "text/markdown" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `referenz_${slug}.md`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  return (
    <section className="wizard-section" data-inqa-step="3">
      <h2 className="form-title">INQA: Referenz herunterladen</h2>
      <p className="form-description">
        Die Projektreferenz ist fertig. Lade sie als DOCX oder Markdown herunter.
      </p>
      {error && (
        <div className="info-box" role="alert" style={{ marginBottom: "0.75rem" }}>
          {error}{" "}
          <button type="button" className="link-button" onClick={() => setError(null)}>
            Schließen
          </button>
        </div>
      )}
      <div className="form-actions" style={{ gap: "0.75rem", flexWrap: "wrap" }}>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => void handleDocx()}
          disabled={!slug || docxBusy}
        >
          {docxBusy ? "Generiere DOCX…" : "Download DOCX"}
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleMarkdown}
          disabled={!slug}
        >
          Download Markdown
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onNewReferenz}
        >
          Weitere Referenz erstellen
        </button>
      </div>
    </section>
  );
}
